import { render, staticRenderFns } from "./SpecialPermanentExhibits.vue?vue&type=template&id=5b8541f3&scoped=true&"
import script from "./SpecialPermanentExhibits.vue?vue&type=script&lang=js&"
export * from "./SpecialPermanentExhibits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8541f3",
  null
  
)

export default component.exports